import {HookAPI} from "antd/es/modal/useModal";
import {ModalFuncProps} from "antd";

export class ModalService{
    static modalApi:HookAPI;
    static init(messageApi:HookAPI){
        this.modalApi=messageApi;
    }
    static confirm(props: ModalFuncProps){

        this.modalApi.confirm(props);
    }
}